import { ComponentProps, useEffect } from 'react';
import Badge from 'src/components/Badge';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
type Props = ComponentProps<typeof Badge> & {
  referrer: string;
  target: string;
  trigger: string;
};
export const RedDot = ({
  referrer,
  target,
  trigger,
  ...restProps
}: Props) => {
  useEffect(() => {
    pushEvent({
      eventName: EVENT_NAME.ANYWHERE__IMPRESSION_RED_DOT,
      eventType: EVENT_TYPE.REDDOT,
      eventParams: {
        action_category: 'impression',
        tab: 'anywhere',
        page: 'anywhere',
        target: 'reddot',
        referrer,
        trigger
      }
    });
  }, [referrer, target, trigger]);
  return <Badge {...restProps} data-sentry-element="Badge" data-sentry-component="RedDot" data-sentry-source-file="index.tsx" />;
};